import React from 'react';
import {get} from 'lodash';
import axios from 'axios';
import { bool, string, func } from 'prop-types'

import {
  addNotification,
  CSRF_TOKEN,
  _setUntil,
  noteDisabled
} from '../lib/helpers';

import Modal from './Modal';
import Notification from './Notification';

class NoteEditModal extends React.Component {

  static propTypes = {
    onToggleModal: func.isRequired,
    createPath: string.isRequired,
    isActive: bool.isRequired
  }

  state = {
    isLoading: false
  }

  _createNote = ($els) => {
    let note = {
      note: $els.note.value,
    }

    axios.post(get(this.props, 'createPath'), {
      note,
      authenticity_token: CSRF_TOKEN,
    })
      .then((res) => {
        if (res.status == 201 && get(res, 'data.message')) {
          addNotification({
            message: get(res, 'data.message'),
            type: Notification.NOTIFICATION_TYPES.success,
          })
        }
      })
      .catch((error) => {
        addNotification({
          message: get(error, 'response.data.message'),
          type: Notification.NOTIFICATION_TYPES.error,
        })
      })
      .then(() => {window.location.reload()})
  };

  onSubmit = (e) => {
    e.preventDefault()
    const $els = e.target.elements
    this._createNote($els)
  };

  render = () => {
    return (
      <Modal
        isActive={this.props.isActive}
        onToggleModal={this.props.onToggleModal}
      >
        <form onSubmit={this.onSubmit}>
          <h3 className='Modal__h3'>
            Writing note
          </h3>

          <div className='UserNoteEditModal'>
            {!noteDisabled() &&
              <textarea
                className='Input'
                rows={5}
                placeholder='Write description …'
                name='note'
              />
            }
          </div>

          <div className='Modal__footer'>
            <a
              className='Button Button--gray-light'
              onClick={this.props.onToggleModal}
            >
              Cancel
            </a>

            <button
              className='Button Button--blue'
              disabled={this.state.isLoading}
            >
              {this.state.isLoading ? 'Loading …' : 'Submit'}
            </button>
          </div>
        </form>
      </Modal>
    );
  }
}

export default NoteEditModal;
